// client/src/api/revi/InstitutionsReviApi.js
//
// Cliente del panel admin Educa360 tab Instituciones (/admin/revi).
// Llama a los endpoints backend `/institutionrevi/*`. El listado global
// usa `/institutionrevi/all` (requireAdmin); el resto reutiliza los
// endpoints existentes que ya servian al panel partner REVI.

import { ENV } from "../../Utils";

const BASE = `${ENV.BASE_API}/institutionrevi`;
const BASE_PROFILE = `${ENV.BASE_API}/institutionreviprofile`;

function headers(token, extra = {}) {
  return { Authorization: `Bearer ${token}`, ...extra };
}

async function asJson(response) {
  let body = null;
  try {
    body = await response.json();
  } catch (e) {
    body = null;
  }
  if (!response.ok) {
    const err = new Error((body && body.message) || `HTTP ${response.status}`);
    err.status = response.status;
    err.body = body;
    throw err;
  }
  return body;
}

function buildFormData(data) {
  const formData = new FormData();
  Object.entries(data || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (k === "avatarFile") {
      formData.append("avatar", v);
      return;
    }
    formData.append(k, v);
  });
  return formData;
}

export class InstitutionsReviApi {
  async listAll(token, { search, partner, active, page = 1, limit = 20 } = {}) {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (partner) params.append("partner", partner);
    if (active !== undefined && active !== "" && active !== null) {
      params.append("active", String(active));
    }
    params.append("page", String(page));
    params.append("limit", String(limit));
    const r = await fetch(`${BASE}/all?${params}`, { headers: headers(token) });
    return asJson(r);
  }

  async getById(token, id) {
    const r = await fetch(`${BASE_PROFILE}/get/${id}`, {
      headers: headers(token),
    });
    return asJson(r);
  }

  async create(token, data) {
    const r = await fetch(`${BASE}/create`, {
      method: "POST",
      headers: headers(token),
      body: buildFormData(data),
    });
    return asJson(r);
  }

  async update(token, id, data) {
    const r = await fetch(`${BASE}/${id}`, {
      method: "PATCH",
      headers: headers(token),
      body: buildFormData(data),
    });
    return asJson(r);
  }

  async remove(token, id) {
    const r = await fetch(`${BASE}/${id}`, {
      method: "DELETE",
      headers: headers(token),
    });
    return asJson(r);
  }

  async toggleActive(token, id, active) {
    const r = await fetch(`${BASE}/activation/${id}`, {
      method: "PATCH",
      headers: headers(token, { "Content-Type": "application/json" }),
      body: JSON.stringify({ active }),
    });
    return asJson(r);
  }
}
